<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-flex xs3>
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          class="searchbar"
        ></v-text-field>
      </v-flex>
    <v-flex xs9>
      <v-spacer />
    </v-flex>

    </v-flex>
    <v-data-table
      :headers="headers"
      :items="$store.state.partNumbers"
      class="elevation-3 item-table"
      :search="search"
      :loading="$store.state.loading > 0"
      :pagination.sync="pagination"
      item-key="itemId"
    >
      <template slot="headers" slot-scope="props">
        <tr class="headerrow">
          <th class="headercell" v-for="header in props.headers" :key="header.text" @click="changeSort(header.value)">
            {{header.text}} <v-icon small v-if="header.value === 'itemId'">{{ pagination.descending ? 'arrow_downward' : 'arrow_upward' }}</v-icon></th>
        </tr>
      </template>
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template v-slot:items="props">
        <tr v-if="editingItem !== props.item.itemId">
          <td class="justify-center layout px-0" nowrap>
            <v-icon
              small
              class="mr-2"
              @click="editPrice(props.item.itemId)"
            >fa-edit</v-icon>
          </td>
          <td>{{ props.item.itemId }}</td>
          <td class="headercell">{{ props.item.description }}</td>
          <td class="text-xs-right">{{ props.item.ciscoRefreshListPrice }}</td>
          <td>{{ props.item.repairVendor }}</td>
          <td class="text-xs-right">{{ props.item.minimumVersion }}</td>
          <td class="text-xs-right">{{ formatMoney(props.item.approvedPrice) }}</td>
          <td>{{ props.item.approvedDate }}</td>
          <td>{{ props.item.approvedBy }}</td>
        </tr>
        <tr v-if="editingItem === props.item.itemId">
          <td class="justify-center layout px-0" nowrap>
            <v-icon
              small
              class="mr-2"
              @click="savePrice(props.item)"
            >save</v-icon>
          </td>
          <td><v-text-field hide-details label="Item Id" v-model="props.item.itemId"/></td>
          <td><v-text-field hide-details label="Description" v-model="props.item.description"/></td>
          <td><v-text-field hide-details label="Cisco Price" v-model="props.item.ciscoRefreshListPrice"/></td>
          <td><v-select
            :items="vendors"
            label="Vendor"
            v-model="props.item.repairVendor"
            item-text="_id"
            item-value="_id"
          ></v-select></td>
          <td><v-text-field hide-details label="Min. Version" v-model="props.item.minimumVersion"/></td>
          <td class="text-xs-right"><v-text-field hide-details label="Approved Price" prefix="$" v-model="props.item.approvedPrice"/></td>
          <td>{{ props.item.approvedDate }}</td>
          <td>{{ props.item.approvedBy }}</td>
        </tr>
      </template>
      <template v-slot:actions-prepend>
        <v-btn color="success" @click="addItem = true">Add Item</v-btn>
      </template>
    </v-data-table>
    <v-dialog
        v-model="addItem"
        width="300"
        v-if="addItem"
    >
      <v-card>
       <v-card-title>
          <v-icon
            small
            left
          >
            add
          </v-icon>
          <span class="title">Add New Item</span>
        </v-card-title>
        <v-card-text>
          <div><v-text-field hide-details label="Item Id" v-model="newItem.itemId"/></div>
          <div><v-text-field hide-details label="Description" v-model="newItem.description"/></div>
          <div>{{ newItem.ciscoRefreshListPrice }}</div>
          <div><v-select
              :items="vendors"
              label="Vendor"
              v-model="newItem.repairVendor"
              item-text="_id"
              item-value="_id"
            ></v-select></div>
          <div><v-text-field hide-details label="Description" v-model="newItem.minimumVersion"/></div>
          <div><v-text-field hide-details label="Price" prefix="$" v-model="newItem.approvedPrice"/></div>
          <div>{{ newItem.approvedDate }}</div>
          <div>{{ newItem.approvedBy }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" @click="saveNewItem()">Save Item</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import formatters from '../formatting';
import http from '../http';
import { baseApiUrl } from '../config';
import moment from 'moment';

export default {
  name: "ItemList",
  data() {
    return {
      headers: [
        { text: "Actions", value: "actions" },

        { text: "Part Number", value: "itemId", sortable: true },
        { text: "Description", value: "description" },
        { text: "Cisco Refresh List Price", value: "ciscoRefreshListPrice" },
        { text: "Repair Vendor", value: "repairVendor" },
        { text: "Minimum Version", value: "minimumVersion" },

        { text: "Approved Price", value: "approvedPrice" },
        { text: "Approved Date", value: "approvedDate" },
        { text: "Approved By", value: "approvedBy" }
      ],
      filter: "All",
      search: "",

      vendors: [],

      addItem: false,
      newItem: {},
      editingItem: undefined,
      pagination: {
        rowsPerPage: 15
      }
    };
  },
  methods: {
    changeSort (column) {
      if (column !== 'itemId') return;

      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    editPrice(itemId) {
      console.log("editPrice itemId:", itemId);
      this.editingItem = itemId;
    },
    async savePrice(item) {
      console.log('savePrice item:', item);
      this.editingItem = undefined;
      // if (!item.approvedPrice) return;
      
      item.approvedPrice = Number.parseFloat(item.approvedPrice);
      item.approvedDate = moment();
      item.approvedBy = this.$store.state.user.attributes.name;

      await http.post(`${baseApiUrl}/admin/item/${item._id}`, item);
    },
    async saveNewItem() {
      console.log('Save new item:', this.newItem);
      this.addItem = false;
      await http.post(`${baseApiUrl}/admin/item/${this.newItem._id}`, this.newItem);

      this.newItem = {};

      this.$store.dispatch('LOAD_PART_NUMBERS');
    },
    formatMoney(value) {
      if (!value) return;
      return formatters.money(value);
    }
  },
  async beforeCreate() {
    console.log('fetching vendors...');
    const vendors = await http.get(`${baseApiUrl}/vendors`);
    this.vendors = vendors.data;
  },
  mounted() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'Admin', disabled: true },
      { text: 'Item List', disabled: true },
    ]);
  },
};
</script>

<style>
.item-table {
  table-layout: fixed !important;
}

.headerrow {
  padding: 2px;
}

.headercell {
  white-space: normal !important;
}

.searchbar {
  margin-bottom: 5px;
}
</style>
